module.exports = __webpack_public_path__ + "static/media/spending.a66b44d5.webp";